import React, { useRef, useEffect, useContext, useState } from 'react'
import { dataURLtoFile, fileToBase64 } from '@/utils'
import { RendererContext } from '@/components/FURenderkit'
import './index.scss'
import { RENDER_SDK, RESOURCE_MANAGER } from '@/config'
import { Button, Col, Form, message, Row, Select, Upload, UploadFile } from 'antd'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import FUIcon from '@/components/Common/FUIcon'
import { AvatarContext, isPC } from '@/components/RenderComp/Avatar'
import SaveAvatarBtn from '@/components/Common/SaveAvatarBtn'
import { Toast } from 'antd-mobile'

const uploadButton = (
    <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
    </div>
);
enum GENDER {
    male,
    female
}

export const isMobile = () => {
    return /(iPhone|iPad|iPod|iOS|Android|Linux armv8l|Linux armv7l|Linux aarch64)/i.test(navigator.platform);
}

const AvatarCreator = (props) => {
    const { renderer } = useContext(RendererContext)
    const { scheduleUpdateAvatar } = useContext(AvatarContext)
    const [imgList, setImgList] = useState<any[]>([])
    const canvasContextRef = useRef<any>(null)
    const canvasRef = useRef<HTMLCanvasElement>(null)
    const videoRef = useRef<HTMLVideoElement>(null)
    const [canvasWidth, setCanvasWidth] = useState(0)
    const [canvasHeight, setCanvasHeight] = useState(0)
    const [imgSrc, setImgSrc] = useState('')
    const [avatarData, setAvatarData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [cameraId, setCameraId] = useState('')
    const [cameraList, setCameraList] = useState<any[]>([])
    useEffect(() => {
        setCanvasWidth(isMobile() ? 600 : videoRef.current?.clientWidth || 0)
        setCanvasHeight(isMobile() ? 600 : videoRef.current?.clientHeight || 0)
    }, [])

    useEffect(() => {
        if (canvasHeight && canvasWidth && !imgSrc && !avatarData && isPC) {
            getCompetence()
        }
    }, [canvasHeight, canvasWidth, imgSrc, avatarData])
    const navigatorRef = useRef<any>(null)
    const getCompetence = async () => {
        if (!canvasRef.current || !videoRef.current) return
        canvasContextRef.current = canvasRef.current.getContext("2d");
        const navigatorHack: any = navigatorRef.current = navigator
        // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象        
        if (navigatorHack.mediaDevices === undefined) {
            navigatorHack.mediaDevices = {};
        }
        // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象        
        // 使用getUserMedia，因为它会覆盖现有的属性。        
        // 这里，如果缺少getUserMedia属性，就添加它。
        console.log('getUserMedia', navigatorHack.mediaDevices.getUserMedia)
        if (navigatorHack.mediaDevices.getUserMedia === undefined) {
            navigatorHack.mediaDevices.getUserMedia = function (constraints) {
                // 首先获取现存的getUserMedia(如果存在)            
                var getUserMedia =
                    navigatorHack.webkitGetUserMedia ||
                    navigatorHack.mozGetUserMedia ||
                    navigatorHack.getUserMedia;
                // 有些浏览器不支持，会返回错误信息           
                // 保持接口一致            
                if (!getUserMedia) {
                    return Promise.reject(
                        new Error("getUserMedia is not implemented in this browser")
                    );
                }
                // 否则，使用Promise将调用包装到旧的navigator.getUserMedia            
                return new Promise(function (resolve, reject) {
                    getUserMedia.call(navigatorHack, constraints, resolve, reject);
                });
            };
        }
        if ((window as unknown as any).stream) {//一进来的时候判断是否开着摄像头         
            (window as unknown as any).stream.getTracks().forEach(track => {
                track.stop();
            });
        }
        const devices = await navigatorHack.mediaDevices.enumerateDevices()
        const cameras = devices
            .filter(device => device.kind === 'videoinput')
            .map(item => ({
                label: item.label,
                value: item.deviceId
            }))
        setCameraList(cameras)
        changeCamera(cameras[0]?.value)
    }

    const changeCamera = async (v) => {
        stopNavigator()
        const navigatorHack: any = navigatorRef.current
        setCameraId(v)
        try {
            var constraints = {//配置默认前置摄像头,以及手机上摄像头取到的画面宽高          
                audio: false,
                video: {
                    width: canvasWidth,
                    height: canvasHeight,
                    // transform: "scaleX(-1)",
                    deviceId: v,
                    // facingMode: { exact: v }
                },
            };
            const stream = await navigatorHack.mediaDevices.getUserMedia(constraints)
            // 旧的浏览器可能没有srcObject
            if (!videoRef.current) return
            videoRef.current.srcObject = stream;
            videoRef.current.play();
        } catch (err) {
            console.log("错误");
            console.log(err);
        }
    }

    const uploadInput = useRef<any>(null)
    const onGenerate = () => {
        if (uploadInput.current) {
            uploadInput.current.click()
        }
    }
    const getImage = () => {
        if (!videoRef.current) return
        // 点击，canvas画图       
        canvasContextRef.current.scale(-1, 1)
        canvasContextRef.current.drawImage(
            videoRef.current,
            -parseInt(`${canvasWidth}`),  //镜像翻转要往负方向移动图片的距离
            0,
            canvasWidth,
            canvasHeight
        );
        // 停止摄像机
        // 获取图片base64链接        
        var dataUrl = canvasRef.current?.toDataURL("image/jpeg", 0.5);
        setImgSrc(dataUrl || '')
        videoRef.current.pause();
        // stopNavigator();
    }
    // 关闭摄像头      
    const stopNavigator = () => {
        if (
            videoRef.current && videoRef.current.srcObject
        ) {
            (videoRef.current.srcObject as unknown as any).getTracks()[0].stop();
        }
    }

    const handleChange = async (file) => {
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
            message.warning({
                content: '仅支持png/jpg/jpeg格式照片',
            })
            return
        }
        const res = await fileToBase64(file)
        imgList.push({
            id: imgList.length,
            url: res.data,
            file
        })
        setImgList([...imgList])
    }

    const selectImage = (img) => {
        setImgSrc(img.url)
    }

    const deleteImage = (e, img) => {
        e.stopPropagation()
        setImgSrc('')
        setImgList(imgList.filter(item => item.id !== img.id))
    }

    const goBack = () => {
        setImgSrc('')
        setAvatarData(null)
    }

    const saveImage = async (gender: GENDER) => {
        console.log('imgSrc', imgSrc)
        let file = dataURLtoFile(imgSrc, 'pic')
        setLoading(true)
        try {
            const avatarData = await RESOURCE_MANAGER.genarateAvatar({
                image: file,
                gender
            })
            message.success('形象生成成功！')
            setAvatarData(avatarData)
        } catch (e) {
            message.error('未捕获到人脸！')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            if (avatarData && !loading) {
                if (!renderer) {
                    RESOURCE_MANAGER.defaultAvatar = {
                        data: avatarData
                    }
                } else {
                    scheduleUpdateAvatar({
                        data: avatarData,
                    })
                }
            }
        })()
    }, [avatarData, loading])

    const changeFile = async (e) => {
        const file = e.target.files[0]
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
            Toast.show({
                icon: 'fail',
                content: '仅支持png/jpg/jpeg格式照片',
            })
            return
        }
        var reader = new FileReader();

        reader.onload = function (e) {
            setImgSrc(e?.target?.result as string)
        }

        reader.readAsDataURL(file)

    }

    return (
        <div className="creator-content">
            {
                avatarData && (
                    <SaveAvatarBtn
                        className="capture-btn"
                    />
                )
            }
            {
                (!!imgSrc || avatarData) && !loading && (
                    <>
                        <div className="back-btn" onClick={goBack}>
                            <FUIcon
                                name="slices/icon_withdraw_nor.png"
                                size="48px"
                            ></FUIcon>
                        </div>
                        <Button
                            className='back-btn back-btn-text'
                            onClick={() => {
                                goBack()
                                if (!isPC) {
                                    onGenerate()
                                }
                            }}
                        >
                            重拍
                        </Button>
                    </>
                )
            }
            {
                !avatarData && (
                    <>
                        <div className={'camera-wrap' + (loading ? ' loading' : '')}>
                            {
                                loading && (
                                    <div className='loading'>
                                        <FUIcon
                                            size="120px"
                                            name="slices/icon_loading.png"
                                        />
                                    </div>
                                )
                            }
                            {
                                imgSrc ? (
                                    <>
                                        <div className='img-wrap'>
                                            <img
                                                src={imgSrc}
                                                style={{
                                                    maxWidth: '100dvw',
                                                }}
                                            />
                                        </div>
                                        <div className="tip">
                                            <p>请选择性别</p>
                                            <div>
                                                <img src={require('./male.png')} className="circle" onClick={() => saveImage(GENDER.male)} />
                                                <img src={require('./female.png')} className="circle" onClick={() => saveImage(GENDER.female)} />
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {
                                            isPC ? <>
                                                <video ref={videoRef} style={{ background: '#fff' }}></video>
                                                <div className="tip">
                                                    <p>请将人脸对准中心区域</p>
                                                    <Button
                                                        className='shot-btn'
                                                        onClick={getImage}
                                                    >
                                                        拍照
                                                    </Button>
                                                </div>
                                            </> : <>
                                                <div className="tip">
                                                    <Button
                                                        className='shot-btn'
                                                        onClick={onGenerate}
                                                    >
                                                        拍照
                                                    </Button>
                                                </div>
                                            </>
                                        }

                                    </>
                                )
                            }
                            <canvas
                                ref={canvasRef}
                                width={canvasWidth}
                                height={canvasHeight}
                                style={{
                                    display: 'none',
                                }}
                            >
                            </canvas>
                        </div>
                        <div style={{ padding: '16px' }} className='camera-controller'>
                            <p className="title">AI形象生成</p>
                            <Form
                                className="animation-list better-scroll"
                            >
                                <Form.Item label="摄像头">
                                    <Select
                                        options={cameraList}
                                        value={cameraId}
                                        onChange={changeCamera}
                                    />
                                </Form.Item>
                                <Form.Item label="图片上传">
                                    <span style={{ fontSize: '12px' }}>支持.jpg或.png (为了保证效果，建议上传800*800图片)</span>
                                </Form.Item>
                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <Upload
                                        multiple
                                        accept='image/*'
                                        listType="picture-card"
                                        beforeUpload={handleChange}
                                        showUploadList={false}
                                    >
                                        {uploadButton}
                                    </Upload>
                                    {
                                        imgList.map((img) => (
                                            <div
                                                key={img.id}
                                                className={(imgSrc === img.url ? 'active ' : '') + 'preview-image'}
                                                style={{ backgroundImage: `url(${img.url})` }}
                                                onClick={() => selectImage(img)}
                                            >
                                                <Button
                                                    danger
                                                    size='small'
                                                    shape="circle"
                                                    icon={<DeleteOutlined />}
                                                    onClick={(e) => deleteImage(e, img)}
                                                />
                                            </div>
                                        ))
                                    }
                                </div>
                            </Form>
                        </div>
                    </>
                )
            }
            <input
                ref={uploadInput}
                type="file"
                accept='image/*'
                onChange={changeFile}
                style={{ display: 'none' }}
            />
        </div>
    )
}

export default AvatarCreator
